module.exports = {"511523100":"江安镇","511523101":"红桥镇","511523104":"怡乐镇","511523105":"留耕镇","511523108":"五矿镇","511523109":"迎安镇","511523110":"夕佳山镇","511523112":"铁清镇","511523113":"四面山镇","511523114":"大井镇","511523115":"阳春镇","511523116":"大妙镇","511523117":"仁和镇","511523118":"下长镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511523.json
// module id = 2490
// module chunks = 0